export default {
  methods: {
    enableWidget(id) {
      this.$analytics.events.showedWidget(id);
      this.$store.dispatch('ui/enableDashboard', id).then(()=> { this.$store.dispatch('user/updateDatum'); });
    },
    removeRequested(id) {
      this.$analytics.events.hideWidget(id);
      this.$store.dispatch('ui/disableDashboard', id).then(()=> { this.$store.dispatch('user/updateDatum'); });
    },
    widgetName(id) {
      const dashboards = Object.values(this.$store.getters['dashboards/get']);
      let name = 'Show Question of the Day';
      let info;

      for (const dashboard of dashboards) {
        info = dashboard.appDashboardsDashboardWidgets.find(w => w.id == id);
        if (info) {
          break;
        }
      }
      if (info?.dashboardWidgetId) {
        const widget = this.$store.getters['dashboardWidgets/widgets'][info.dashboardWidgetId];
        name = 'Show ' + widget.name;
      }
      return name;
    },
    userDisabled(id) {
      const disabledDashboards = this.$store.getters['ui/disabledDashboards'];
      const i = disabledDashboards.indexOf(id);
      return i >= 0;
    },
  },
  computed: {
    disabledWidgets() {
      return this.$store.getters['ui/disabledDashboards'];
    },
  },
};
